module.exports = __webpack_public_path__ + "files/99c553c2add10ab7e1d5dbe885b3abf1.png";